<template>
<div id="modals">
  <div class="popup-cab popup-auth">
    <div class="popup-cab__wrap">
      <button class="popup-thanks__close auth-close">
        <img src="/static/img/cart_close.svg" alt="close" width="20" height="20">
      </button>
      <h2 class="section-title">Войти</h2>
      <p>Для авторизации введите номер телефона и мы отправим код-пароль через SMS</p>
      <div class="popup-cab__phone">
        <input class="popup-cab__input" type="tel" placeholder="+7">
        <a href="#" class="popup-cab__btn auth-next">Далее</a>
      </div>
    </div>
  </div>
  <div class="popup-cab popup-change">
    <div class="popup-cab__wrap">
      <div class="popup-cab__wrap">
        <button class="popup-thanks__close">
          <img src="/static/img/cart_close.svg" alt="close" width="20" height="20">
        </button>
        <h2 class="section-title">Смена телефона</h2>
        <p>Для смены телефона введите новый номер и мы отправим код-пароль через SMS</p>
        <div class="popup-cab__phone">
          <input class="popup-cab__input" type="tel" placeholder="+7">
          <a href="#" class="popup-cab__btn">Далее</a>
        </div>
      </div>
    </div>
  </div>
  <div class="popup-cab popup-sms">
    <div class="popup-cab__wrap">
      <button class="popup-thanks__close sms-close">
        <img src="/static/img/cart_close.svg" alt="close" width="20" height="20">
      </button>
      <h2 class="section-title">Введите код из SMS</h2>
      <div class="popup-sms__wrap">
        <input type="text" maxlength="1">
        <input type="text" maxlength="1">
        <input type="text" maxlength="1">
        <input type="text" maxlength="1">
      </div>
    </div>
  </div>
</div>
</template>

<script>
  export default {
      name: 'modals'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modals.vue